import "./styles/product.css";
import "./styles/product-form.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import BrandCreate from "./pages/Brand/BrandCreate.tsx";
import Layout from "./layout/Layout.jsx";
import TaxCreate from "./pages/Tax/TaxCreate.tsx";
import CategoriesCreate from "./pages/Categorie/CategoriesCreate.tsx";
import ProductClassification from "./pages/Classification/Mapping/ProductClassification.tsx";
import MediaLibrary from "./pages/Media/MediaLibrary.tsx";
import MediaLibraryCreate from "./pages/Media/MediaLibraryCreate.tsx";
import NotFound from "./layout/NotFound.jsx";
import ProductList from "./pages/Product/ProductList.tsx";
import ProductView from "./pages/Product/Create/ProductView.tsx";
import ProductkeyPage from "./pages/ProductKey/ProductkeyPage.tsx";
import LoginPage from "./pages/Login/LoginPage.tsx";
import PagesList from "./pages/Sections/PagesList.tsx";
import SectionsList from "./pages/Sections/SectionsList.tsx";
import ProductCreate from "./pages/Product/Create/ProductCreate.tsx";
import BrandsBulk from "./pages/Bulk/Brands/BrandsBulk.tsx";
import CategoriesBulk from "./pages/Bulk/Categories/CategoriesBulk.tsx";
import ProductBulkUpload from "./pages/Bulk/Products/ProductBulkUpload.tsx";
import BrandList from "./pages/Brand/BrandList.tsx";
import CategoriesList from "./pages/Categorie/CategoriesList.tsx";
import TaxList from "./pages/Tax/TaxList.tsx";
import CouponList from "./pages/Coupon/CouponLIst.tsx";
import DiscountList from "./pages/Discount/DiscountList.tsx";
import SellerList from "./pages/Seller/SellersList.tsx";
import ClassificationList from "./pages/Classification/ClassificationsList.tsx";
import CampaignList from "./pages/Campaign/CampaignList.tsx";
import OrderList from "./pages/Orders/OrdersList.tsx";
import CouponCreate from "./pages/Coupon/CouponCreate.tsx";
import DiscountCreate from "./pages/Discount/DiscountCreate.tsx";
import ClassificationCreate from "./pages/Classification/ClassificationCreate.tsx";
import CampaignCreate from "./pages/Campaign/CampaignCreate.tsx";
import ProductCampaign from "./pages/Campaign/Mapping/ProductCampaign.tsx";
import ProductEdit from "./pages/Product/Edit/ProductEdit.tsx";
import Dashboard from "./pages/Dashboard/Dashboard.tsx";
import SubPageList from "./pages/Appearance/SubPage/SubPageList.tsx";
import AdsList from "./pages/Appearance/Ads/AdsList.tsx";
import FaqCategoriesList from "./pages/Appearance/FaqCategorys/FaqCategoriesList.tsx";
import FaqLIst from "./pages/Appearance/Faq/FaqLIst.tsx";
import AboutUsList from "./pages/AboutUs/AboutUsList.tsx";
import BlogsList from "./pages/Appearance/Blogs/BlogsList.tsx";
import BlogCategories from "./pages/Appearance/BlogCategory/BlogCategory.tsx";
import BlogTags from "./pages/Appearance/BlogTags/BlogTags.tsx";
import FaqCreate from "./pages/Appearance/Faq/FaqCreate.tsx";
import SubpagesCreate from "./pages/Appearance/SubPage/SubPagesCreate.tsx";
import AdsCreate from "./pages/Appearance/Ads/AdsCreate.tsx";
import BlogsCreate from "./pages/Appearance/Blogs/BlogCreate.tsx";
import SellerCreate from "./pages/Seller/SellerCreate.tsx";
import CommonSettings from "./pages/Settings/CommonSettings.tsx";
import SettingsGroupList from "../src/pages/Settings/SettingsGroupList.tsx";
import SettingSingleList from "./pages/Settings/SettingSingleList.tsx";
import OrderCreate from "../src/pages/Orders/OrderCreate.tsx";
import MenuBoard from "./pages/Menu/MenuBoard.tsx";
import VaraiantList from "../src/pages/Varaiant/VaraiantList.tsx";
import MediaBulk from "./pages/Bulk/Media/MediaBulk.tsx";
import Truncate from "./pages/Truncate/Truncate.tsx";
import MenuList from "./pages/Menu/MenuList.tsx";
import MenuFile from "./pages/Media/MediaZipFile.tsx";
import CustomersList from "./pages/Customer/CustomersList.tsx";

import { useEffect, useState } from "react";
import SellersList from "./pages/Seller/SellersList.tsx";
import OrderVeiw from "./pages/Orders/OrderVeiw.tsx";
import CasetteUpload from "./pages/Cassette/CasetteUpload.tsx"
function App() {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(
    localStorage.getItem("isAdminAuthenticated") === "true"
  );

  const [isRestricted, setIsRestricted] = useState(false);
  const [productKeyState, setProductKeyState] = useState(
    localStorage.getItem("productKeyState") === "false"
  );

  localStorage.setItem("productKeyState", productKeyState);

  useEffect(() => {
    const adminToken = localStorage.getItem("admin_token");
    setIsAdminAuthenticated(!!adminToken);
  }, []);

  useEffect(() => {
    const checkDeviceWidth = () => {
      const isSmallDevice = window.innerWidth <= 767;
      setIsRestricted(isSmallDevice);
    };

    checkDeviceWidth();
    window.addEventListener("resize", checkDeviceWidth);

    return () => {
      window.removeEventListener("resize", checkDeviceWidth);
    };
  }, []);


  if (isRestricted) {
    return (
      <div className="device-restricted">
        This application is only available on laptops and tablets.
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Toaster />
      <Routes>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route
          path="/admin"
          element={
            <LoginPage
              setIsAdminAuthenticated={setIsAdminAuthenticated}
              setProductKeyState={setProductKeyState}
            />
          }
        />
        <Route
          path="/*"
          element={
            isAdminAuthenticated ? <MainRoutes /> : <Navigate to="/" replace />
          }
        />
        {productKeyState && (
          <Route
            path="/product-key"
            element={<ProductkeyPage setProductKeyState={setProductKeyState} />}
          />
        )}
      </Routes>
    </BrowserRouter>
  );
}
function MainRoutes() {
  return (
    <Routes>
      <Route
        path="/product-veiw"
        element={<Layout children={<ProductView />} />}
      />
      <Route
        path="product-list"
        element={<Layout children={<ProductList />} />}
      />
      <Route
        path="product-create"
        element={<Layout children={<ProductCreate />} />}
      />
      <Route
        path="classification-map"
        element={<Layout children={<ProductClassification />} />}
      />
      <Route
        path="brand-create"
        element={<Layout children={<BrandCreate />} />}
      />
      <Route
        path="/categories-create"
        element={<Layout children={<CategoriesCreate />} />}
      />
      <Route
        path="/media-list"
        element={<Layout children={<MediaLibrary />} />}
      />
      <Route
        path="/media-create"
        element={<Layout children={<MediaLibraryCreate />} />}
      />
      <Route path="*" element={<NotFound />} />
      <Route path="/pages-list" element={<Layout children={<PagesList />} />} />
      <Route
        path="/pages-list/sections"
        element={<Layout children={<SectionsList />} />}
      />
      <Route
        path="/bulk-brands"
        element={<Layout children={<BrandsBulk />} />}
      />
      <Route
        path="/bulk-categories"
        element={<Layout children={<CategoriesBulk />} />}
      />
      <Route
        path="/bulk-products"
        element={<Layout children={<ProductBulkUpload />} />}
      />
      <Route path="brand-list" element={<Layout children={<BrandList />} />} />
      <Route
        path="/categories-list"
        element={<Layout children={<CategoriesList />} />}
      />
      <Route path="/tax-list" element={<Layout children={<TaxList />} />} />
      <Route path="/tax-create" element={<Layout children={<TaxCreate />} />} />
      <Route
        path="/coupon-list"
        element={<Layout children={<CouponList />} />}
      />
      <Route
        path="/discount-list"
        element={<Layout children={<DiscountList />} />}
      />
      <Route
        path="/classification-list"
        element={<Layout children={<ClassificationList />} />}
      />
      <Route
        path="/sellers-list"
        element={<Layout children={<SellerList />} />}
      />
      <Route
        path="/classifications-list"
        element={<Layout children={<ClassificationList />} />}
      />
      <Route
        path="/campaign-list"
        element={<Layout children={<CampaignList />} />}
      />
      <Route
        path="/orders-list"
        element={<Layout children={<OrderList />} />}
      />
      <Route
        path="/coupon-create"
        element={<Layout children={<CouponCreate />} />}
      />
      <Route
        path="/discount-create"
        element={<Layout children={<DiscountCreate />} />}
      />
      <Route
        path="/classification-create"
        element={<Layout children={<ClassificationCreate />} />}
      />
      <Route
        path="/campaign-create"
        element={<Layout children={<CampaignCreate />} />}
      />
      <Route
        path="campaign-map"
        element={<Layout children={<ProductCampaign />} />}
      />
      <Route
        path="/product-edit"
        element={<Layout children={<ProductEdit />} />}
      />
      <Route
        path="/sub-pages-list"
        element={<Layout children={<SubPageList />} />}
      />
      <Route path="ads-list" element={<Layout children={<AdsList />} />} />
      <Route
        path="faq-category"
        element={<Layout children={<FaqCategoriesList />} />}
      />
      <Route path="faq-list" element={<Layout children={<FaqLIst />} />} />
      <Route path="about-us" element={<Layout children={<AboutUsList />} />} />
      <Route path="blog-list" element={<Layout children={<BlogsList />} />} />
      <Route
        path="blog-category"
        element={<Layout children={<BlogCategories />} />}
      />
      <Route path="blog-tags" element={<Layout children={<BlogTags />} />} />
      <Route path="/faq-create" element={<Layout children={<FaqCreate />} />} />
      <Route
        path="sub-pages-create"
        element={<Layout children={<SubpagesCreate />} />}
      />
      <Route path="ads-create" element={<Layout children={<AdsCreate />} />} />
      <Route
        path="blog-create"
        element={<Layout children={<BlogsCreate />} />}
      />
      <Route
        path="seller-list"
        element={<Layout children={<SellersList />} />}
      />
      <Route
        path="seller-create"
        element={<Layout children={<SellerCreate />} />}
      />
      <Route path="/dashboard" element={<Layout children={<Dashboard />} />} />
      <Route
        path="/control-settings-board"
        element={<Layout children={<CommonSettings />} />}
      />
      <Route
        path="/settings-group"
        element={<Layout children={<SettingsGroupList />} />}
      />
      <Route path="/order-veiw" element={<Layout children={<OrderVeiw />} />} />
      <Route
        path="/settings-menu"
        element={<Layout children={<SettingSingleList />} />}
      />
      <Route
        path="/orders-create"
        element={<Layout children={<OrderCreate />} />}
      />
      <Route
        path="/variants-list"
        element={<Layout children={<VaraiantList />} />}
      />
      <Route path="/bulk-media" element={<Layout children={<MediaBulk />} />} />
      <Route
        path="/menus-board"
        element={<Layout children={<MenuBoard />} />}
      />
      <Route path="/menus-list" element={<Layout children={<MenuList />} />} />
      <Route
        path="/control-truncate-board"
        element={<Layout children={<Truncate />} />}
      />
      <Route
        path="/media-zip-upload"
        element={<Layout children={<MenuFile />} />}
      />
      <Route
        path="/customers-list"
        element={<Layout children={<CustomersList />} />}
      />
      <Route
        path="/control-cassette"
        element={<Layout children={<CasetteUpload />} />}
      />
    </Routes>
  );
}
export default App;
